import type { ReactNode } from "react";

// Letterhead print-CSS sheet — browser print, no PDF library (architecture.md §11).
// The page's normal content is hidden via @media print rules in index.css; only the
// element with class "glut-print-sheet" renders when the user prints.
export function DocumentPrintSheet({
  title,
  docNo,
  meta,
  children,
}: {
  title: string;
  docNo: string;
  meta: { label: string; value: string }[];
  children: ReactNode;
}) {
  return (
    <div className="glut-print-sheet">
      <div style={{ padding: 24 }}>
        <h2 style={{ marginBottom: 4 }}>Glut Investments Pvt Ltd</h2>
        <h3 style={{ marginTop: 0 }}>
          {title} — {docNo}
        </h3>
        <table style={{ width: "100%", marginBottom: 16 }}>
          <tbody>
            {meta.map((m) => (
              <tr key={m.label}>
                <td style={{ fontWeight: 600, paddingRight: 12, width: 160 }}>{m.label}</td>
                <td>{m.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {children}
        <div style={{ marginTop: 48, display: "flex", justifyContent: "space-between" }}>
          <div>Prepared by: _______________</div>
          <div>Received by: _______________</div>
        </div>
      </div>
    </div>
  );
}
